export const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: "smooth", // Optionnel : effet de défilement en douceur
    });
};
